import React from 'react';
import experiments from '@reverbdotcom/commons/src/experiments';
import { useUser, inExperiment } from '@reverbdotcom/commons/src/user_hooks';
import window from '@reverbdotcom/commons/src/window_wrapper';
import { Paths } from '@reverbdotcom/commons/src/url_helpers';
import { updateGoogleConsent, IPrivacyConsentSettings } from '@reverbdotcom/commons/src/google';
import { V3 } from './api_request';
import UserPrivacyConsentPopup from './user_privacy_consent_popup';
import UserPrivacySettingModal from './user_privacy_setting_modal';
import Location from '../lib/wrapped_location';


export function showUserPrivacyConsent(user) {
  const showThirdPartyPrivacyConsentBannerExp = inExperiment(user, experiments.GOOGLE_CONSENT_MODE);
  const requireThirdPartyPrivacyConsentBanner = user.requireThirdPartyPrivacyConsent;

  return showThirdPartyPrivacyConsentBannerExp && requireThirdPartyPrivacyConsentBanner;
}

export function submitRequest(privacyConsentSettings: IPrivacyConsentSettings, user) {
  const mparticleId = window.mParticle.Identity.getCurrentUser?.().getMPID();
  const {
    adData,
    adStorage,
    adPersonalization,
    analyticsStorage,
  } = privacyConsentSettings;
  const isGoogleConsentModeOn = inExperiment(user, experiments.GOOGLE_CONSENT_MODE);

  V3.post(Paths.privacySettingsUpdate.expand({}),
    {
      third_party_ad_data_consent: adData,
      third_party_ad_storage_consent: adStorage,
      third_party_ad_personalization_consent: adPersonalization,
      third_party_analytics_storage_consent: analyticsStorage,
      mparticle_id: mparticleId,
    },
  ).then(() => {
    if (isGoogleConsentModeOn) {
      updateGoogleConsent({
        'adData': adData,
        'adStorage': adStorage,
        'adPersonalization': adPersonalization,
        'analyticsStorage': analyticsStorage,
      });
    }
    Location.assign(Location.href);
  });
}

export default function UserPrivacyConsentContainer() {
  const user = useUser();

  const [privacyConsentSettings, setPrivacyConsentSettings] = React.useState({
    adData: true,
    adStorage: true,
    adPersonalization: true,
    analyticsStorage: true,
  } as IPrivacyConsentSettings);
  const [isUserPrivacyConsentPopupOpen, setUserPrivacyConsentPopupOpen] = React.useState(true);
  const [isUserPrivacySettingModalOpen, setUserPrivacySettingModalOpen] = React.useState(false);
  const toggleUserConsentModals = React.useCallback(() => {
    setUserPrivacyConsentPopupOpen(false);
    setUserPrivacySettingModalOpen(true);
  }, []);
  const updatePrivacySettings = React.useCallback((e) => {
    setPrivacyConsentSettings({
      ...privacyConsentSettings,
      [e.target.id]: e.target.checked,
    } as IPrivacyConsentSettings);
  }, [privacyConsentSettings]);
  const onSubmit = () => {
    submitRequest(
      privacyConsentSettings,
      user,
    );
  };

  return (
    <>
      <UserPrivacyConsentPopup
        isOpen={isUserPrivacyConsentPopupOpen}
        onClose={toggleUserConsentModals}
        onSubmit={onSubmit}
      />
      <UserPrivacySettingModal
        isAdDataChecked={privacyConsentSettings.adData}
        isAdStorageChecked={privacyConsentSettings.adStorage}
        isAdPersonalizationChecked={privacyConsentSettings.adPersonalization}
        isAnalyticsStorageChecked={privacyConsentSettings.analyticsStorage}
        updatePrivacySettings={updatePrivacySettings}
        onSubmit={onSubmit}
        isOpen={isUserPrivacySettingModalOpen}
        allowBackgroundScroll
      />
    </>
  );
}
